import { Typography, Box } from '@mui/material';

const AppVersion = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                bottom: 0,
                background: '#e8e8e8',
                width: '100%',
                left: 0,
                padding: '10px',
                gap: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Box sx={{ textAlign: 'center' }}>
                {/* <Typography variant="h6">Digital Robot Dash</Typography> */}
                <Typography variant="subtitle2">{process.env.REACT_APP_CURRENT_VERSION || 'v1.0.0'}</Typography>
            </Box>
        </Box>
    );
};
export default AppVersion;
